module.exports = __webpack_public_path__ + "img/aspirant-grey.f90abd7a.png";